import { useSyncExternalStore } from 'react';

const supported = (): boolean => typeof window.matchMedia === 'function';

/** Whether a CSS media query matches, kept up to date (false where matchMedia is missing). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (!supported()) return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => {
        list.removeEventListener('change', onChange);
      };
    },
    () => supported() && window.matchMedia(query).matches,
    () => false,
  );
}

/** Below this the app is a read-only chart viewer (docs/PLAN.md §1). */
export const COMPACT_QUERY = '(max-width: 1023px)';
